<p id="title" class="headline-small">
  {{ 'moveCaseDialog.title' | translate }}
</p>
<mat-dialog-content id="content">
  <div class="flexColumnContainer">
    <span id="text" class="body-medium">{{ 'moveCaseDialog.textBeforeCaseName' | translate }}<strong>{{ caseName }}</strong>{{ 'moveCaseDialog.textAfterCaseName' | translate }}</span>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'moveCaseDialog.searchTeam.label' | translate }}</mat-label>
      <input type="text"
             [placeholder]="'moveCaseDialog.searchTeam.placeholder' | translate"
             aria-label="Search for target team"
             matInput
             [formControl]="teamSearchControl"
             [matAutocomplete]="auto">
      <mat-icon class="material-symbols-outlined" matPrefix>group_search</mat-icon>
      <mat-autocomplete class="body-large" autoActiveFirstOption #auto="matAutocomplete"
                        [displayWith]="displayTeamName"
                        (optionSelected)="teamSelected($event)">
        @for (team of filteredTeams | async; track team.identification) {
          <mat-option [value]="team">{{ team.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>
    {{ 'moveCaseDialog.buttons.cancel.label' | translate }}
  </button>
  <button mat-flat-button [mat-dialog-close]="chosenTeam"
          [disabled]="!chosenTeam">
    {{ 'moveCaseDialog.buttons.move.label' | translate }}
  </button>
</mat-dialog-actions>
